export default __webpack_public_path__ + "static/media/ProfilePic.85a4ae1a.jpeg";